// Generated by Melange

import ArtistPageModuleCss from "./artistPage.module.css";
import * as ReactRouter from "@tanstack/react-router";
import * as Belt__Belt_Array from "melange.belt/belt_Array.jsx";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Router__Link from "../router/link.jsx";
import * as Shared__Album from "../shared/album.jsx";
import * as Shared__AlbumCard from "../shared/albumCard.jsx";
import * as Shared__ArtistCard from "../shared/artistCard.jsx";
import * as Shared__CardGrid from "../shared/cardGrid.jsx";
import * as Shared__Container from "../shared/container.jsx";
import * as Shared__EmptyState from "../shared/emptyState.jsx";
import * as Shared__H1 from "../shared/h1.jsx";
import * as Shared__H2 from "../shared/h2.jsx";
import * as Shared__MediaHeader from "../shared/mediaHeader.jsx";
import * as Shared__MediaLinks from "../shared/mediaLinks.jsx";
import * as Shared__Prose from "../shared/prose.jsx";
import * as Shared__Skeleton from "../shared/skeleton.jsx";
import * as Shared__SongList from "../shared/songList.jsx";
import * as Shared__StarButton from "../shared/starButton.jsx";
import * as Shared__Tabs from "../shared/tabs.jsx";
import * as Stdlib__Array from "melange/array.jsx";
import * as Stdlib__Int from "melange/int.jsx";
import * as Stdlib__List from "melange/list.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Store__Context from "../store/context.jsx";
import Clsx from "clsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = ArtistPageModuleCss;

function ArtistPage$TopSongsSection(Props) {
  let children = Props.children;
  let params = Props.params;
  return JsxRuntime.jsxs("section", {
    children: [
      JsxRuntime.jsx(Shared__H2.make, {
        children: JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, "Top songs", undefined, "top-songs", {
          behavior: "instant",
          block: "start"
        }, {
          artistId: params.artistId
        }, false, "/artist/$artistId", undefined)),
        className: css.mainTabSectionHeading
      }),
      children
    ]
  });
}

const TopSongsSection = {
  make: ArtistPage$TopSongsSection
};

function ArtistPage$SimilarArtistsSection(Props) {
  let artistId = Props.artistId;
  let presentArtists = Props.presentArtists;
  return JsxRuntime.jsxs("section", {
    children: [
      JsxRuntime.jsx(Shared__H2.make, {
        children: JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, "Similar artists", undefined, "similar-artists", {
          behavior: "instant",
          block: "start"
        }, {
          artistId: artistId
        }, false, "/artist/$artistId", undefined)),
        className: css.mainTabSectionHeading
      }),
      JsxRuntime.jsx(Shared__CardGrid.make, {
        children: presentArtists !== undefined ? presentArtists.slice(0, 6).map(function (id) {
            const Key = String(id);
            return JsxRuntime.jsx(Shared__ArtistCard.make, {
              coverArtSizes: Shared__CardGrid.card_grid_cover_art_sizes,
              id: id,
              loadCoverArtLazily: true
            }, Key);
          }) : Belt__Belt_Array.mapWithIndex(Belt__Belt_Array.make(6, undefined), (function (i, param) {
            const Key = String(i);
            return JsxRuntime.jsx(Shared__ArtistCard.make, {}, Key);
          }))
      })
    ]
  });
}

const SimilarArtistsSection = {
  make: ArtistPage$SimilarArtistsSection
};

function ArtistPage(Props) {
  let deferredArtistInfo = Props.deferredArtistInfo;
  let deferredSimilarArtists = Props.deferredSimilarArtists;
  let deferredTopSongIds = Props.deferredTopSongIds;
  let initialAlbumIds = Props.initialAlbumIds;
  let initialArtist = Props.initialArtist;
  let params = Props.params;
  const tabValue = ReactRouter.useRouterState({
    select: (function (state) {
      if (state.location.hash === "") {
        return "main";
      } else {
        return state.location.hash;
      }
    })
  });
  const artist = Store__Context.useAppStore(function (state) {
    return Stdlib__Option.value(Stdlib__Option.map(Stdlib__Option.some, Caml_option.undefined_to_opt(state.artists.byId.get(params.artistId))), initialArtist);
  });
  const renderArtistInfo = function (fallbackOpt, children) {
    const fallback = fallbackOpt !== undefined ? Caml_option.valFromOption(fallbackOpt) : JsxRuntime.jsx(React.Fragment, {
        children: null
      });
    return JsxRuntime.jsx(Store__Context.Consumer.make, {
      children: (function (artistInfo) {
        if (artistInfo !== undefined) {
          return Curry._1(children, artistInfo);
        } else if (deferredArtistInfo !== undefined) {
          return JsxRuntime.jsx(ReactRouter.Await, {
            fallback: fallback,
            promise: Caml_option.valFromOption(deferredArtistInfo),
            children: children
          });
        } else {
          return fallback;
        }
      }),
      selector: (function (state) {
        return Caml_option.undefined_to_opt(state.artists.artistInfoById.get(params.artistId));
      })
    });
  };
  const renderSimilarArtists = function (fallbackOpt, children) {
    const fallback = fallbackOpt !== undefined ? Caml_option.valFromOption(fallbackOpt) : JsxRuntime.jsx(React.Fragment, {
        children: null
      });
    return JsxRuntime.jsx(Store__Context.Consumer.make, {
      children: (function (similarArtists) {
        if (similarArtists !== undefined) {
          return Curry._1(children, similarArtists);
        } else if (deferredSimilarArtists !== undefined) {
          return JsxRuntime.jsx(ReactRouter.Await, {
            fallback: fallback,
            promise: Caml_option.valFromOption(deferredSimilarArtists),
            children: children
          });
        } else {
          return fallback;
        }
      }),
      selector: (function (state) {
        return Caml_option.undefined_to_opt(state.artists.similarArtistsById.get(params.artistId));
      })
    });
  };
  const renderTopSongs = function (fallbackOpt, children) {
    const fallback = fallbackOpt !== undefined ? Caml_option.valFromOption(fallbackOpt) : JsxRuntime.jsx(React.Fragment, {
        children: null
      });
    return JsxRuntime.jsx(Store__Context.Consumer.make, {
      children: (function (topSongIds) {
        if (artist !== undefined && topSongIds !== undefined) {
          return Curry._2(children, artist, topSongIds);
        }
        if (artist !== undefined && deferredTopSongIds !== undefined) {
          return JsxRuntime.jsx(ReactRouter.Await, {
            fallback: fallback,
            promise: Caml_option.valFromOption(deferredTopSongIds),
            children: (function (topSongIds) {
              return Curry._2(children, artist, topSongIds);
            })
          });
        } else {
          return fallback;
        }
      }),
      selector: (function (state) {
        return Stdlib__Option.bind(artist, (function (artist) {
          return Caml_option.undefined_to_opt(state.artists.topSongIdsByArtistName.get(artist.name));
        }));
      })
    });
  };
  const albumIds = Store__Context.useAppStore(function (state) {
    return Stdlib__Option.value(Stdlib__Option.map(Stdlib__Option.some, Caml_option.undefined_to_opt(state.artists.albumIdsByArtistId.get(params.artistId))), initialAlbumIds);
  });
  let tmp;
  if (artist !== undefined) {
    let tmp$1 = {
      artistId: artist.id,
      className: css.starButton
    };
    if (artist.starred !== undefined) {
      tmp$1.starred = Caml_option.valFromOption(artist.starred);
    }
    tmp = JsxRuntime.jsxs(Shared__H1.make, {
      children: [
        JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, Caml_option.some(artist.name), undefined, undefined, undefined, {
          artistId: params.artistId
        }, undefined, "/artist/$artistId", undefined)),
        JsxRuntime.jsx(Shared__StarButton.make, tmp$1)
      ]
    });
  } else {
    tmp = JsxRuntime.jsx(Shared__H1.make, {
      children: JsxRuntime.jsx(Shared__Skeleton.make, {
        style: {
          width: "16rem"
        }
      })
    });
  }
  return JsxRuntime.jsxs(Shared__Container.make, {
    children: [
      JsxRuntime.jsx(Shared__MediaHeader.make, {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: "Artist",
                  className: css.tag
                }),
                tmp,
                JsxRuntime.jsx("div", {
                  children: artist !== undefined ? JsxRuntime.jsxs(ReactRouter.Link, Router__Link.makeProps(undefined, [
                      artist.albumCount,
                      " albums"
                    ], undefined, "albums", {
                      behavior: "instant",
                      block: "start"
                    }, {
                      artistId: params.artistId
                    }, undefined, "/artist/$artistId", undefined)) : JsxRuntime.jsx(Shared__Skeleton.make, {
                      style: {
                        width: "5rem"
                      }
                    }),
                  className: css.subtitle
                })
              ]
            }),
            renderArtistInfo(Caml_option.some(JsxRuntime.jsx(Shared__Prose.make, {})), (function (details) {
              const arg = null;
              let param = Stdlib__Option.map((function (html) {
                return JsxRuntime.jsx(Shared__Prose.make, {
                  html: html
                });
              }), details.biography);
              return Stdlib__Option.value(param, arg);
            }))
          ],
          className: css.artistInfo
        }),
        coverArt: Stdlib__Option.map((function (x) {
          return x.coverArt;
        }), artist),
        links: renderArtistInfo(Caml_option.some(JsxRuntime.jsx(Shared__MediaLinks.make, {
          skeleton: true
        })), (function (artistInfo) {
          let tmp = {};
          if (artistInfo.lastFmUrl !== undefined) {
            tmp.lastFmUrl = Caml_option.valFromOption(artistInfo.lastFmUrl);
          }
          const tmp$1 = Stdlib__Option.map((function (musicBrainzId) {
            return "https://musicbrainz.org/artist/" + musicBrainzId;
          }), artistInfo.musicBrainzId);
          if (tmp$1 !== undefined) {
            tmp.musicBrainzUrl = Caml_option.valFromOption(tmp$1);
          }
          return JsxRuntime.jsx(Shared__MediaLinks.make, tmp);
        }))
      }),
      JsxRuntime.jsxs(Shared__Tabs.Root.make, {
        children: [
          JsxRuntime.jsxs(Shared__Tabs.List.make, {
            children: [
              JsxRuntime.jsx(Shared__Tabs.Trigger.make, {
                children: JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, "Main", undefined, "main", {
                  behavior: "instant",
                  block: "nearest"
                }, {
                  artistId: params.artistId
                }, false, "/artist/$artistId", undefined)),
                value: "main"
              }),
              JsxRuntime.jsx(Shared__Tabs.Trigger.make, {
                children: JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, "Top songs", undefined, "top-songs", {
                  behavior: "instant",
                  block: "nearest"
                }, {
                  artistId: params.artistId
                }, false, "/artist/$artistId", undefined)),
                value: "top-songs"
              }),
              JsxRuntime.jsx(Shared__Tabs.Trigger.make, {
                children: JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, "Albums", undefined, "albums", {
                  behavior: "instant",
                  block: "nearest"
                }, {
                  artistId: params.artistId
                }, false, "/artist/$artistId", undefined)),
                value: "albums"
              }),
              JsxRuntime.jsx(Shared__Tabs.Trigger.make, {
                children: JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, "Similar artists", undefined, "similar-artists", {
                  behavior: "instant",
                  block: "nearest"
                }, {
                  artistId: params.artistId
                }, false, "/artist/$artistId", undefined)),
                value: "similar-artists"
              })
            ],
            className: Clsx(css.tabsList, tabValue !== "main" ? css.tabsList_sticky : undefined)
          }),
          JsxRuntime.jsxs(Shared__Tabs.Content.make, {
            children: [
              renderTopSongs(Caml_option.some(JsxRuntime.jsx(ArtistPage$TopSongsSection, {
                children: JsxRuntime.jsx(Shared__SongList.make, {}),
                params: params
              })), (function (artist, topSongIds) {
                if (topSongIds.length !== 0) {
                  return JsxRuntime.jsx(ArtistPage$TopSongsSection, {
                    children: JsxRuntime.jsx(Shared__SongList.make, {
                      getSongElementId: Shared__Album.getSongElementId,
                      primaryArtist: artist.name,
                      songIds: topSongIds.slice(0, 5),
                      songIdsToPlay: topSongIds
                    }),
                    params: params
                  });
                } else {
                  return null;
                }
              })),
              JsxRuntime.jsxs("section", {
                children: [
                  JsxRuntime.jsx(Shared__H2.make, {
                    children: JsxRuntime.jsx(ReactRouter.Link, Router__Link.makeProps(undefined, "Albums", undefined, "albums", {
                      behavior: "instant",
                      block: "start"
                    }, {
                      artistId: params.artistId
                    }, false, "/artist/$artistId", undefined)),
                    className: css.mainTabSectionHeading
                  }),
                  JsxRuntime.jsx(Shared__CardGrid.make, {
                    children: albumIds !== undefined ? Belt__Belt_Array.reverse(albumIds).slice(0, 6).map(function (id) {
                        return JsxRuntime.jsx(Shared__AlbumCard.make, {
                          coverArtSizes: Shared__CardGrid.card_grid_cover_art_sizes,
                          id: id,
                          loadCoverArtLazily: true
                        }, id);
                      }) : Belt__Belt_Array.mapWithIndex(Belt__Belt_Array.make(6, undefined), (function (i, param) {
                        const Key = Stdlib__Int.to_string(i);
                        return JsxRuntime.jsx(Shared__AlbumCard.make, {}, Key);
                      }))
                  })
                ]
              }),
              renderSimilarArtists(Caml_option.some(JsxRuntime.jsx(ArtistPage$SimilarArtistsSection, {
                artistId: params.artistId
              })), (function (similarArtists) {
                const presentArtists = Stdlib__Array.of_list(Stdlib__List.filter_map((function (artist) {
                  if (artist.TAG === /* Artist */ 0) {
                    return artist._0.id;
                  }
                  
                }), Stdlib__Array.to_list(similarArtists)));
                if (presentArtists.length !== 0) {
                  return JsxRuntime.jsx(ArtistPage$SimilarArtistsSection, {
                    artistId: params.artistId,
                    presentArtists: presentArtists
                  });
                } else {
                  return null;
                }
              }))
            ],
            className: css.mainTab,
            value: "main"
          }),
          JsxRuntime.jsx(Shared__Tabs.Content.make, {
            children: renderTopSongs(Caml_option.some(JsxRuntime.jsx(Shared__SongList.make, {})), (function (artist, topSongIds) {
              if (topSongIds.length === 0) {
                return JsxRuntime.jsx(Shared__EmptyState.make, {
                  message: "No top songs"
                });
              } else {
                return JsxRuntime.jsx(Shared__SongList.make, {
                  getSongElementId: Shared__Album.getSongElementId,
                  primaryArtist: artist.name,
                  songIds: topSongIds
                });
              }
            })),
            value: "top-songs"
          }),
          JsxRuntime.jsx(Shared__Tabs.Content.make, {
            children: JsxRuntime.jsx(Shared__CardGrid.make, {
              children: albumIds !== undefined ? Belt__Belt_Array.reverse(albumIds).map(function (id) {
                  return JsxRuntime.jsx(Shared__AlbumCard.make, {
                    coverArtSizes: Shared__CardGrid.card_grid_cover_art_sizes,
                    id: id,
                    loadCoverArtLazily: true
                  }, id);
                }) : Belt__Belt_Array.mapWithIndex(Belt__Belt_Array.make(12, undefined), (function (i, param) {
                  const Key = Stdlib__Int.to_string(i);
                  return JsxRuntime.jsx(Shared__AlbumCard.make, {}, Key);
                }))
            }),
            value: "albums"
          }),
          JsxRuntime.jsx(Shared__Tabs.Content.make, {
            children: renderSimilarArtists(Caml_option.some(JsxRuntime.jsx(Shared__CardGrid.make, {
              children: Belt__Belt_Array.mapWithIndex(Belt__Belt_Array.make(12, undefined), (function (i, param) {
                const Key = Stdlib__Int.to_string(i);
                return JsxRuntime.jsx(Shared__ArtistCard.make, {}, Key);
              }))
            })), (function (similarArtists) {
              if (similarArtists.length === 0) {
                return JsxRuntime.jsx(Shared__EmptyState.make, {
                  message: "No similar artists"
                });
              }
              const presentArtists = Stdlib__Array.of_list(Stdlib__List.filter_map((function (artist) {
                if (artist.TAG === /* Artist */ 0) {
                  return artist._0.id;
                }
                
              }), Stdlib__Array.to_list(similarArtists)));
              const notPresentArtists = Stdlib__Array.of_list(Stdlib__List.filter_map((function (info) {
                if (info.TAG === /* Artist */ 0) {
                  return;
                } else {
                  return info._0.name;
                }
              }), Stdlib__Array.to_list(similarArtists)));
              return JsxRuntime.jsxs("div", {
                children: [
                  presentArtists.length === 0 ? null : JsxRuntime.jsx(Shared__CardGrid.make, {
                      children: presentArtists.map(function (id) {
                        return JsxRuntime.jsx(Shared__ArtistCard.make, {
                          coverArtSizes: Shared__CardGrid.card_grid_cover_art_sizes,
                          id: id,
                          loadCoverArtLazily: true
                        }, id);
                      })
                    }),
                  notPresentArtists.length === 0 ? null : JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Shared__H2.make, {
                          children: "Not found in a library:"
                        }),
                        JsxRuntime.jsx("ul", {
                          children: notPresentArtists.map(function (similarArtist) {
                            return JsxRuntime.jsx("li", {
                              children: JsxRuntime.jsx("a", {
                                children: similarArtist,
                                href: "https://www.last.fm/music/" + encodeURIComponent(similarArtist),
                                rel: "noopener",
                                target: "_blank"
                              }),
                              className: css.similarArtistsTabNotPresentItem
                            }, similarArtist);
                          }),
                          className: css.similarArtistsTabNotPresentList
                        })
                      ],
                      className: css.similarArtistsTabNotPresent
                    })
                ],
                className: css.similarArtistsTab
              });
            })),
            value: "similar-artists"
          })
        ],
        value: tabValue
      })
    ],
    className: css.root
  });
}

const make = ArtistPage;

export {
  TopSongsSection,
  SimilarArtistsSection,
  make,
}
/* css Not a pure module */
